var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-document"},[(_vm.pdf)?_c('PDFViewer',{attrs:{"pdf-document":_vm.pdf,"show-form-fields":_vm.showFormFields},on:{"page-rendered":_vm.pageRendered,"scroll":function($event){return _vm.$emit('scroll')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }